import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import { MessageBox } from 'element-ui'

let urlObjects={};
axios.interceptors.request.use(
	config => {
		if(config.url[0]=='@'){
			config.url=config.url.slice(config.url[1]=='/'?2:1);
			return config;
		}
		config.baseURL=WEBCONFIG.connectPath;
		if(config.method=='add'){
			config.method='post';
		}
		else if(config.method=='edit'){
			config.method='put';
		}

		// if(config.method!='get'){
		// 	let url=config.method+':'+config.baseURL+config.url;
		// 	const message='数据处理中，请勿重复提交';
		// 	if(urlObjects[url]!=null){
		// 		if(urlObjects[url].timestamp!=null){
		// 			if(new Date().getTime()-urlObjects[url].timestamp<=1000){
		// 				throw new Error(message);
		// 			}
		// 			else{
		// 				delete urlObjects[url];
		// 			}
		// 		}
		// 		else{
		// 			throw new Error(message);
		// 		}
		// 	}
		// 	urlObjects[url]={};
		// }

		if(store.state.app.token!='')
			config.headers['Authorization'] = store.state.app.token;
		if(WEBCONFIG.system!=null)
			config.headers['system'] = WEBCONFIG.system;
		if(config.data!=null&&config.urlencode){
			config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
			config.transformRequest = [function (data, headers) {
				return qs.stringify(data/*,{allowDots:true}*/);
			}];
		}

		return config;
	},error => {
		return Promise.reject(error);
	}
)
let isAuth=true;
axios.interceptors.response.use(
	response=>{
		if(!response.config.baseURL){
			return response.data;
		}
		let url=response.config.method+':'+response.config.baseURL+response.config.url;
		if(response.config.method!='get'){
			urlObjects[url]={timestamp:new Date().getTime()};
		}

		if (response.data.status === 401) {
			if(isAuth){
				isAuth=false;
				MessageBox(response.data.message).then(()=>{
					throw new Error();
				}).catch(()=>{
					store.commit('removeToken');
					router.push({name:'login'});
				});
			}
			throw new Error('');
		}
		isAuth=true;
		if (response.data.status === 200) {
			if(response.data.total!=undefined)
				return {list:response.data.data,total:response.data.total};
			return response.data.data;
		}
		if(response.data){
			if(response.config.method!='get'){
				delete urlObjects[url];
			}
			let error=new Error(response.data.message+'\n'+(response.data.data!=null?response.data.data:''));
			error.response=response;
			throw error;
		}
		let error=new Error('请求结果异常');
		error.response=response;
		throw error;
	},
	error => {
		urlObjects={};
		return Promise.reject(error);
	}
)

const install = function(Vue, opts = {}) {
	Vue.prototype.$axios = axios;

	let messages={};
	let showMsgBox=false;

	let msgBoxList=Vue.extend({
		template: `<div class="msgboxlist">
			<div v-for="(v,k) in messages" class="msgboxlist-item" :key="k">
				<span class="msgboxlist-count" v-if="v>1||Object.keys(messages).length>1">{{v}}</span>
				<span class="msgboxlist-text">{{k}}</span>
			</div>
		</div>`,
		data(){
			return {
				messages:messages
			};
		}
	});
	let addMessage=(msg)=>{
		if(messages[msg]==null)
			Vue.set(messages,msg,0);
		messages[msg]++;
	};

	Promise.prototype.end=function(){
		this.catch((error)=>{
			if(error.message==''){
				return;
			}

			addMessage(error.message);
			if(!showMsgBox){
				showMsgBox=true;

				let h=new Vue().$createElement;
				MessageBox({
					message:h(msgBoxList)
				}).then((action, instance)=>{
					showMsgBox=false;
					for(let key in messages) {
						delete messages[key]
					}
				}).catch(e=>{
					showMsgBox=false;
					for(let key in messages) {
						delete messages[key]
					}
				});
			}
		});
	}
}

export default {
	install:install,
}
